import { defineMessages } from 'react-intl';

// Title (+ optional help) for each feature row. The titles double as the tooltip
// labels (e.g. "Battery discharge: active"), so this is the single source.
export const messages = defineMessages({
  priceLevelTitle: {
    id: 'spot.summary.price_level',
    defaultMessage: 'Hladina ceny',
  },
  priceLevelHelp: {
    id: 'spot.summary.price_level.help',
    defaultMessage:
      'Infigy seřadí hodinové ceny spotu od nejnižší po nejvyšší a rozdělí je do tří částí, přibližně stejně velkých. Pokud hodinnové ceny začínají na hodnotě 3 Kč a končí na hodnotě 10 Kč, tak nízká cena může mít roztpyl 3-6 Kč, střední 6-7 Kč a vysoká 7-10 Kč. Rozptyl bude každý den jiný, záleží na četnosti hodnot v dané cenové hladině.',
  },
  priceLevel15MTitle: {
    id: 'spot.summary.price_level_15m',
    defaultMessage: 'Hladina ceny 15m',
  },
  spotOverflowTitle: {
    id: 'spot.summary.spotOverflow',
    defaultMessage: 'Přetok do sítě',
  },
  spotOverflowHelp: {
    id: 'spot.summary.spotOverflow.help',
    defaultMessage:
      'Povolení přetoku do sítě při spotovém obchodování porovnává cenu spotu v danou hodinu a pokud je nižší než Cena pro zákaz přetoků z nastavení, tak systém automaticky v danou hodinu přetok zakáže.',
  },
  batteryDischargeTitle: {
    id: 'spot.summary.battery_discharge',
    defaultMessage: 'Vybíjení baterie',
  },
  batteryDischargeHelp: {
    id: 'spot.summary.battery_discharge.help',
    defaultMessage:
      'Vybíjení baterie do objektu na spotu je možné zakázat či povolit. Lze tak udělat v nastavení. Vybíjení baterie se obvykle zakazuje v době nízkých cen, kdy je lepší brát energii ze sítě a v baterii ji uchovat na dražší časy.',
  },
  batteryChargeFromGridTitle: {
    id: 'spot.summary.battery_charge_from_grid',
    defaultMessage: 'Nabíjení ze sítě',
  },
  batteryChargeFromGridHelp: {
    id: 'spot.summary.battery_charge_from_grid.help',
    defaultMessage:
      'Nabíjení baterie ze sítě dle spotu je možné zakázat či povolit. Lze tak udělat v nastavení. Nabíjení baterie systém naplánuje v době nízkých cen a bere v potaz aktuální úroveň nabití baterie a její kapacitu. Na základě těchto parametrů zvolí délku nabíjení tak, aby došlo k jejímu plnému nabití za co nejnižší cenu.',
  },
  batteryDischargeToGridTitle: {
    id: 'spot.summary.battery_discharge_to_grid',
    defaultMessage: 'Vybíjení do sítě',
  },
  batteryDischargeToGridHelp: {
    id: 'spot.summary.battery_discharge_to_grid.help',
    defaultMessage:
      'Vybíjení baterie do sítě je možné zakázat či povolit. Lze tak udělat v nastavení. Vybíjení baterie do sítě určí systém v době nejvyšší denní ceny a vybije jen tu energii, která nebude potřeba na běžnou spotřebu objektu.',
  },
  boilerTitle: { id: 'spot.summary.boiler', defaultMessage: 'Bojler' },
  boilerHelp: {
    id: 'spot.summary.boiler.help',
    defaultMessage:
      'Nahřívání bojleru systém naplánuje v době nízkých cen a bere v potaz aktuální teplotu vody v bojleru, jeho kapacitu a požadovanou teplotu. Na základě těchto parametrů zvolí délku nahřívání tak, aby došlo k jeho nahřátí.',
  },
  heatPumpTitle: {
    id: 'spot.summary.heat_pump',
    defaultMessage: 'Tepelné čerpadlo',
  },
  heatPumpHelp: {
    id: 'spot.summary.heat_pump.help',
    defaultMessage:
      'Tepelné čerpadlo může běžet ve třech režimech: zvýšený výkon, běžný chod a omezený výkon. Zvýšený výkon se využívá v době nízkých cen, běžný chod v době středních cen a omezený výkon v době vysokých cen. Odložení spotřeby či zvýšení spotřeby lze povolit v menu tepelného čerpadla.',
  },
});

// Per-slot status strings shown inside the aggregate tooltip (boolean state,
// price level, heat-pump level).
export const tooltipMessages = defineMessages({
  stateActive: { id: 'spot.summary.state.active', defaultMessage: 'Aktivní' },
  stateInactive: {
    id: 'spot.summary.state.inactive',
    defaultMessage: 'Neaktivní',
  },
  priceBuy: {
    id: 'spot.summary.price_buy',
    defaultMessage: 'Cena s distribucí',
  },
  priceSell: {
    id: 'spot.summary.price_sell',
    defaultMessage: 'Cena bez distribuce',
  },
  priceDistribution: {
    id: 'spot.summary.price_distribution',
    defaultMessage: 'Distribuce',
  },
  spotOverflowAllowed: {
    id: 'spot.summary.spotOverflow.allowed',
    defaultMessage: 'Povolený',
  },
  spotOverflowRestricted: {
    id: 'spot.summary.spotOverflow.restricted',
    defaultMessage: 'Omezený',
  },
  priceLevelHi: {
    id: 'spot.summary.price_level.hi',
    defaultMessage: 'Vysoká cena',
  },
  priceLevelMid: {
    id: 'spot.summary.price_level.mid',
    defaultMessage: 'Střední cena',
  },
  priceLevelLow: {
    id: 'spot.summary.price_level.low',
    defaultMessage: 'Nízká cena',
  },
  heatPumpIncrease: {
    id: 'spot.summary.heat_pump_level.increase',
    defaultMessage: 'Zýšený výkon',
  },
  heatPumpNormal: {
    id: 'spot.summary.heat_pump_level.normal',
    defaultMessage: 'Běžný chod',
  },
  heatPumpReduction: {
    id: 'spot.summary.heat_pump_level.reduction',
    defaultMessage: 'Omezený výkon',
  },
});
